import { render, staticRenderFns } from "./HelpRegistration.vue?vue&type=template&id=13873462&scoped=true&"
import script from "./HelpRegistration.vue?vue&type=script&lang=js&"
export * from "./HelpRegistration.vue?vue&type=script&lang=js&"
import style0 from "./HelpRegistration.vue?vue&type=style&index=0&id=13873462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13873462",
  null
  
)

export default component.exports